import { render } from "./BaseAddressAutocomplete.vue?vue&type=template&id=3b2580da&scoped=true"
import script from "./BaseAddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseAddressAutocomplete.vue?vue&type=script&lang=js"

import "./BaseAddressAutocomplete.vue?vue&type=style&index=0&id=3b2580da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2580da"]])

export default __exports__